import React, { Component } from "react";
import moment from "moment";

import clockIconGray from "../img/icons/clock-gray.svg";
import eyeIconGray from "../img/icons/eye-gray.svg";
import "./articleItem.scss";

class ArticleItem extends Component {
  render() {
    return (
      <a
        className="ArticleItem"
        href={this.props.article.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="source">
          <img
            src={
              this.props.article.content.favicon.includes("http")
                ? this.props.article.content.favicon
                : "https://" +
                  this.props.article.url.split("/")[2] +
                  "/" +
                  this.props.article.content.favicon
            }
            alt="News organization"
          />
          <span className="organization">
            {this.props.article.url.split("/")[2].replace("www.", "")}
          </span>
          <span className="date">
            {moment(this.props.article.publish_date).fromNow()}
          </span>
        </div>
        <img src={this.props.article.content.image} alt="Article thumbnail" />
        <div className="content">
          <h2>{this.props.article.title}</h2>
          <p>{this.props.article.content.description}</p>
        </div>
        <div className="data">
          <div className="data-item">
            <img src={clockIconGray} alt="Reading time" />
            <span>{this.props.article.news_metadata.read_time} min</span>
          </div>
          {this.props.article.news_metadata.twitter_all.length > 0 ? (
            <div className="data-item">
              <img src={eyeIconGray} alt="Number of readers" />
              <span>{this.props.article.news_metadata.twitter_all.length}</span>
            </div>
          ) : null}
        </div>
      </a>
    );
  }
}

export default ArticleItem;
